import React, { useEffect, useState, useRef, useContext } from "react";
import { getShops, getUsers, getWarehouses, ListOrder, ListOrderMaster, ListSalesReport, ListUserReport } from "../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { NaviGate, numberToWords } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";

const Increport = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
  const [data, setData] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedReturnInvoice, setSelectedReturnInvoice] = useState(null);
  const [Details, setDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const modalContentRef = useRef(null);

  // Filter states
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [warehouseId, setWarehouseId] = useState("");
  const [empId, setEmpId] = useState("");
  const [users, setUsers] = useState([]);
  const [shops, setShops] = useState([]);
  const [warehouse, setWarehouse] = useState([]);

  useEffect(() => {
    fetchData();
    fetchUsers();
    fetchShops();
    fetchWarehouses();
  }, []);

  const fetchUsers = async (page = "", text = "") => {
    try {
      const response = await getUsers(page, text, shopItem.shop_id);
      if (response.data && response.data.data) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchShops = async (page = 1, text = "") => {
    try {
      const response = await getShops(page, text);
      if (response.data && response.data.data) {
        setShops(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchWarehouses = async () => {
    try {
      const response = await getWarehouses();
      if (response && response.data) {
        setWarehouse(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching warehouses:', error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or undefined date

    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Ensure valid date

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const fetchData = async () => {
    try {
      const formattedFromDate = formatDate(fromDate);
      const formattedToDate = formatDate(toDate);

      var filter = `start_date=${formattedFromDate}&end_date=${formattedToDate}&user_id=${empId}&shop_id=${companyId}`;

      const response = await ListUserReport(filter);
      if (response.data && response.data.data) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    fetchData();
  };

  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
      <NaviGate />
        <h6 className="mt-3 text-uppercase">Income Expense Report</h6>

        {/* Filters Section */}
        <form onSubmit={handleFilter} className="card p-4 shadow-sm">
          <div className="row g-3">
            {/* From Date */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="fromDate"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <label htmlFor="fromDate">From Date</label>
              </div>
            </div>

            {/* To Date */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                <label htmlFor="toDate">To Date</label>
              </div>
            </div>

            {/* Company ID Dropdown */}
            <div className="col-md-2">
              <div className="form-floating">
                <select
                  className="form-select"
                  id="companyId"
                  value={companyId}
                  onChange={(e) => setCompanyId(e.target.value)}
                >
                  <option value="">Select Company</option>
                  {shops?.map((shop) => (
                    <option key={shop.shop_id} value={shop.shop_id}>
                      {shop.shop_title}
                    </option>
                  ))}
                </select>
                <label htmlFor="companyId">Company ID</label>
              </div>
            </div>

            {/* Warehouse ID Dropdown */}
            <div className="col-md-2">
              <div className="form-floating">
                <select
                  className="form-select"
                  id="warehouseId"
                  value={warehouseId}
                  onChange={(e) => setWarehouseId(e.target.value)}
                >
                  <option value="">Select Warehouse</option>
                  {warehouse
                    .map((emp) => (
                      <option key={emp.id} value={emp.id}>
                        {emp.title}
                      </option>
                    ))}
                </select>
                <label htmlFor="warehouseId">Warehouse ID</label>
              </div>
            </div>

            {/* Employee ID Dropdown */}
            <div className="col-md-2">
              <div className="form-floating">
                <select
                  className="form-select"
                  id="empId"
                  value={empId}
                  onChange={(e) => setEmpId(e.target.value)}
                >
                  <option value="">Select Employee</option>
                  {users
                    // .filter((emp) => emp.role_title === "Employee")
                    .map((emp) => (
                      <option key={emp.user_Id} value={emp.user_Id}>
                        {emp.full_name} ({emp.role_title})
                      </option>
                    ))}
                </select>
                <label htmlFor="empId">Employee ID</label>
              </div>
            </div>

            {/* Filter Button */}
            <div className="col-md-2 d-flex align-items-end">
              <button
                type="submit"
                className="btn btn-primary w-100"
                style={{
                  background: 'linear-gradient(45deg, #007bff, #6610f2)',
                  border: 'none',
                }}
              >
                <i className="fas fa-filter"></i> Filter
              </button>
            </div>
          </div>
        </form>

        {/* Table */}
        <div className="table-responsive text-center my-1 w-100 position-relative d-none">
          <table className="table table-striped table-sm table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Role</th>
                <th>Phone</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.full_name}</td>
                  <td>{item.role_title}</td>
                  <td>{item.phone}</td>
                  <td>{item.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default Increport;
